import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "date-rule" }

import DateTimeSelectionModal from "./modals/DateTimeSelectionModal.vue";
import { computed, onMounted, reactive, nextTick, watch } from "vue";
import { useI18n } from "vue-i18n";
import moment from "moment";
import { relativeTimeOptions } from "@util/relativeDate";

type ViewModel = {
  isRelative: boolean | null;
  time: string | undefined;
  key: string | undefined;
  value: number | undefined;
  hasValue: boolean;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'DateRule',
  props: {
    value: {},
    canBeNone: { type: Boolean }
  },
  emits: ["input", "deleteRule"],
  setup(__props: any, { emit: emits }) {

const props = __props;



const { t: $t, d: $d } = useI18n();

const modals = reactive({ open: false });

const localModel = computed({
  get: () => {
    return props.value;
  },
  set: (nv) => {
    emits("input", nv);
  }
});

const vm = reactive<ViewModel>({
  isRelative: null,
  time: undefined,
  key: undefined,
  value: undefined,
  hasValue: false
});

watch(
  () => localModel.value,
  (nv) => {
    if (nv === "unselected") {
      vm.isRelative = false;
      return;
    }

    if (nv === "") {
      vm.isRelative = null;
      return;
    }

    const date = moment(nv);
    if (date.isValid()) {
      vm.isRelative = false;
      vm.time = nv;
      return;
    }

    vm.isRelative = true;
    const match = nv.match(/(\d+)/);
    const num = match ? parseInt(match[1], 10) : NaN;

    if (!Number.isNaN(num)) {
      vm.hasValue = true;
      const backendKey = nv.replace(num.toString(), "{value}");
      const key = relativeTimeOptions.find((o) => o.backendKey?.plural === backendKey || o.backendKey?.singular === nv);
      vm.key = key?.key;
      vm.value = num;
    } else {
      vm.hasValue = false;
      const key = relativeTimeOptions.find((o) => o.backendKey?.singular === nv);
      vm.key = key?.key;
    }
  },
  { immediate: true }
);

const selectedTime = computed(() => {
  if (localModel.value === "unselected") return "";

  if (vm.isRelative === null) {
    return `<${$t("empty")}>`;
  }

  if (!vm.isRelative && vm.time) {
    const format = vm.time?.split(" ").length > 1 ? "shortDateTime" : "shortDate";
    return $d(moment(vm.time).toDate(), format);
  }

  if (vm.value && vm.hasValue) {
    return $t(`relativeDateTimePreview.${vm.key}`, { count: vm.value });
  } else {
    return $t(`relativeDateTimePicker.${vm.key}`);
  }
});

const onConfirm = async (data: string) => {
  localModel.value = data;
};

const onCancel = () => {
  if (localModel.value === "unselected") emits("deleteRule");
};

onMounted(() => {
  nextTick(() => {
    if (localModel.value == "unselected") modals.open = true;
  });
});

return (_ctx: any,_cache: any) => {
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_b_button, {
      variant: "link",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (modals.open = true))
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(selectedTime.value), 1)
      ]),
      _: 1
    }),
    _createVNode(DateTimeSelectionModal, {
      "is-open": modals.open,
      "onUpdate:isOpen": _cache[1] || (_cache[1] = ($event: any) => ((modals.open) = $event)),
      onConfirm: onConfirm,
      onCancelSelection: onCancel,
      "is-relative": vm.isRelative,
      "can-be-none": props.canBeNone,
      time: vm.time,
      "option-key": vm.key,
      "option-value": vm.value
    }, null, 8, ["is-open", "is-relative", "can-be-none", "time", "option-key", "option-value"])
  ]))
}
}

})